"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var accessors_1 = require("../themes/accessors");
var StyledLabel = styled_components_1.default('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 700;\n  font-family: ", ";\n"], ["\n  display: flex;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: 700;\n  font-family: ", ";\n"])), accessors_1.textColor('contrast'), accessors_1.fontSize('label'), accessors_1.fontFamily('sansSerif'));
var Label = function (_a) {
    var label = _a.label, _b = _a.tag, tag = _b === void 0 ? 'label' : _b, otherProps = __rest(_a, ["label", "tag"]);
    return react_1.default.createElement(StyledLabel, __assign({}, otherProps, { as: tag }), label);
};
exports.Label = Label;
var templateObject_1;
